/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "anwxpmxpmqipjstptrek";
export const publicAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFud3hwbXhwbXFpcGpzdHB0cmVrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgyMjg5ODYsImV4cCI6MjA3MzgwNDk4Nn0.0rroIUpZqgTQROLt_Nl_qf8BnSZO9zrCERoS2mV_NNA";
